import { requst } from '../config'

// 日历上数据
export const getLineClearanceCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/lineClearance/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &projectId=${params.projectId}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getLineClearanceDictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 根据日期查询当天数据
export const getLineClearanceByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/lineClearance/getByDate?
            produceDate=${params.produceDate}
            &projectId=${params.projectId}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 保存数据
export const postLineClearanceDataApi = activityData => {
    const url = `/lineClearance/save`
    return requst.post(url, activityData)
}
